import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router';
import { useSelector } from '../redux/store';
import NoPermissionPage from '../pages/NoPermissionPage';
import { PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

ClientGuard.propTypes = {
    children: PropTypes.node,
};

export default function ClientGuard({ children }) {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { rolemodules } = useSelector((state) => state.roleaccess);

    const modules = rolemodules
        ?.flatMap((item) => item?.Modules?.flatMap((item) => item?.childrens?.map((item) => item?.path)))
        .filter((item) => item !== undefined);

    modules?.push(
        '/client/dashboard',
        '/client/master/qr-logs',
        '/client/master/qr-history',
        '/client/master/delay-modules',
        '/client/master/staff'
    );

    const isRouteAllowed = (route) => {
        if (pathname === '/') {
            navigate(PATH_DASHBOARD.clientRoot, { replace: true });
            return true;
        }

        const convertedRoute = route?.replace(/s$/, '');
        return pathname.startsWith(route) || pathname.startsWith(`${convertedRoute}/`);
    };

    if (!modules?.some((item) => isRouteAllowed(item))) {
        return <NoPermissionPage />;
    }

    return <>{children}</>;
}


